import { Component, ElementRef } from '@angular/core';
import moment from 'moment';
import { Moment } from 'moment';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./HistoricalReturns.css'],
  selector: 'HistoricalReturns',
  templateUrl: './HistoricalReturns.html',
})
export class HistoricalReturnComponent extends PageBase {
  constructor(el: ElementRef) {
    super(el, "HistoricalReturns");
  }


  private _fromDate: Moment = moment().startOf('month');
  private _toDate: Moment = moment().endOf('month');

  public get fromDate(): Moment { return this._fromDate; }
  public set fromDate(value: Moment) { this._fromDate = value; }

  public get toDate(): Moment { return this._toDate; }
  public set toDate(value: Moment) { this._toDate = value; }

  public async loadData() {
    //Trigger ngOnChanges on child components
    this.fromDate = this.fromDate.clone();
  }
}
